<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'COMPONENTS.KNOWLEDGE.KNOWLEDGE_ARTICLE' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="exit()" color="primary">
        <ion-icon name="close"/>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <app-shared-knowledge-article-detail [article]="article"/>
</ion-content>
